<template>
  <div>
    <myheader
      :backFlag="true"
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="文件签署"
    ></myheader>
  </div>
</template>

<script>
import {
  Dialog
} from 'vant';
import {
  getUserInfo
} from '../../utils/shareRequest'
import {
  closeCurrentPage,
  downDMToSBox,
  startWhDjSignOrSeal
} from '../../utils/nativeOtherOperate'

import {
  saveEventCertPath,
  getSealCertPath
} from '../../utils/nativeCertSign'
export default {
  data() {
    return {
      //
      resId: '',
      //
      docId: '',
      // 企业id
      corpId: '',
      //
      staffId: '',
      //
      certType: '',
      //
      signetType: '',
      //
      segId: '',
      //
      appCode: '',
      //
      lockId: '',
      //
      fileId: '',
      //
      token: '',
      //
      signetList: '',
      //
      zthcLockId: '',
    }
  },
  methods: {
    //
    back() {
      closeCurrentPage(0)
    },
    //获取esstoken
    getAppToken() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/seal/api/genAppToken', {
        appCode: this.appCode
      }).then((res) => {
        if (res.success && res.data) {
          this.token = res.data
          this.getSealList()
        } else {
          this.showMessageInfoAlert((res.message || res.messageDetail) + ',返回上一级重试！', 0)
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.showMessageInfoAlert('获取token失败，请联系管理员！', 0)
      });
    },
    //获取印模列表
    getSealList() {
      this.$sealp('/api/basic/binding/list?token=' + this.token, {
        corpId: this.corpId,
        staffId: this.staffId,
        certType: this.certType,
        signetType: this.signetType
      }, this.appCode, 'form').then(res => {
        if (res.success && res.data.length > 0) {
          this.signetList = res.data
          if (this.signetList[0]) {
            //this.signetList[0].certSn = '4114755F9484736A8BF94EBDB8322229'
            //this.signetList[1].certSn = '4114755F9484736A8BF94EBDB8322229'
            this.getCertPath()
          } else {
            this.showMessageInfoAlert('没有获取到签名印模列表,请确定签名印模可用，再重试！', 0)
          }
        } else {
          this.showMessageInfoAlert((res.message || res.messageDetail) + ',返回上一级重试！', 0)
        }
      }).catch(err => {
        this.showMessageInfoAlert('签名盖章流程获取印模报错，请联系管理员！', 0)
      })
    },
    //
    getCertPath() {
      if (this.certType === '0') {
        // this.$sealg(`api/doc/sign/eventCert?token=${this.token}`, {
        //   staffId: this.staffId,
        // }, this.appCode).then(res => {
        //   if (res.success && res.data) {
        //     this.getEventCertPath(res.data)
        //   } else {
        //     this.showMessageInfoAlert((res.message || res.messageDetail) + ',返回上一级重试！', 0)
        //   }
        // }).catch(err => {
        //   this.showMessageInfoAlert('签名盖章流程获取证书报错，请联系管理员！', 0)
        // })
        // let data = {
        //   privateKey: 'MIIFKzBVBgkqhkiG9w0BBQ0wSDAnBgkqhkiG9w0BBQwwGgQUfTNQYBeOfGHINd0UffVj9yFR+aACAggAMB0GCWCGSAFlAwQBKgQQTtvC6MQSSwjPYwu8EU7n2wSCBNCk0jWNHCyDnBAdL5jqCoa10/IEBCHq6eE/58NlKOi2BsRFAwgR5BRBpt83BkpooQc4r+l/2l5tsVJjU+grLnq5z8pW0JoPDb7LQWupkNu6qmcmOrR8p5vRddIdAt8lrW00/9ZH4XEKQAfYEA2K8hDKT/5hmmEdWCQpGSTkpwig3gJSmF10e24e2xqiBy/81OZW3g060xqS9XCwTf5Y5pX4MG8GdR86BUXSxYdHwdoXiof1/adFnV1xdB0F3mwzzTX74uDpcPQkJbPkedZ/fzCUJ9E2MNZFn66dJqyAVpyOXP5w+1dWib102xwk7AS86U9izRxWk3GiXRAQ5t3LofUyKV0JZLXpFIFEazu4YLmJ6g7s2T7qas6zLcduaW/Whg4qncHyCOFZB3oNrI7hY+yb3Vmzm8HxVq40W3/4o6MYVnjdJnvWBDKpm+qT49ra+nZ+Pqu3SlzB3a8F/JHyy93PLVhoowlOugAPsgHB5sbcf6BsgzfdJqM9N64Al9MvXrSrZwBeoEPNlEQU8JzoqykbHeYUhDNFXX4fk8tUnvqyFUdXgTJuQyjgLP0o4l3/fDmtY5hDxgZ0Em4lWLUOIYIip1Ex6tI46mfnHmi0h15zq9UfKOKTHB4OdRih2hIOi5StrPHK9DWT3jDKbXfs2ai0NCpSzH4k5hoflu2VHxXq73Oj6Ez/KJmptuShDUIkMGExgNHZCdlSdVWrFQ0EtLOj2ub3LfrLJzxE7erRC6qr40uu/kHDusqLUzNSQ+X8rv9BJ6udY1LO+jNHY7jrvd9Ufgsfl/d+kPReHN/EV8gWqF/jYvAvazn7ZStWhgwFIBLs5mlzcGXygMrbTjLGNz7817ne1dtCEg8L9zpZ1ra37Cg3jN/pwth902nqiZnMBxFOaJLT0KbDrTFTVBsysul02kePSHPi1tWMnuNq6CkvLfb4dmX05bFVtdiVsFtYXcJvlDa6Xa/D/5aQNhBSLUml0UHA7InuS3o6mGbwID8cyVqIMVj6kTI8VngnfYe6IPZtrar0yQtVlr7VLTV6H97cvri4fyZmU7Ok16qAS0+pzY3+bZVMoZFv+RRmljz7xL5QrBf+aE9XNe0yhp8HfTY6dqYQcwD8wjbi5Hp0FYMfl/ijqIzNqb5ajVPGIek388gYZ5tqph3hio/xxfDm7XywcJ21r7QauX7UB1mgu3TcIphiudfvnn8PQvOGDHWLjlAObz78QeSN1y3iC0F/298ulyTfNIIALrKEjeCPegSwZQFt2OLrEwipJpHJ5H1+WL8OUmO/5JqguPhpbBYbsRBuSx9IR2WpOL1gKiNmeKwi5nLtQ0UkDCd11M36W6FXhmJHk2v1bWV+JFpzXeIpqHNzDZrfhAf9PUHZkyxVL0ZfhtFLPkmeizFwwldO/W7Ny4jngJ1tXLB8fMLtZawZUEY6dDe6IEjE7g6b7C65yK035/QRjcLP5gBZBgCIFqPZAVleKJMtE7Scw32wVEDAiQ3UXAzNss+lp44QOblEJC+bQ0bTaq4fHB+h5gutafkNz+L0Q/L1VNjzwxY+Vgb4gD0z5PwQOh45yywwe8YnE+9hK982K5EMXFTcssRlcLOkB49tSvs8sZV4Z6qR6Z9z3DkktLfeC8TuYbOEigVF7JTRog==',
        //   certPem: 'MIIEhzCCA2+gAwIBAgIQG8wl6B8z1E5jmbbpt+AURDANBgkqhkiG9w0BAQsFADCBjDELMAkGA1UEBhMCQ04xEDAOBgNVBAgMB0JFSUpJTkcxDjAMBgNVBAcMBUJFVERBMQ4wDAYDVQQKDAVDSUVDQzEaMBgGA1UECwwRR0ZBIFRSVVNUIE5FVFdPUksxLzAtBgNVBAMMJlJPT1QgQ0VSVElGSUNBVEUgRk9SIEdGQSBUUlVTVCBORVRXT1JLMB4XDTI2MDIxMjA3MTM0M1oXDTI2MDIxMzA3MTM0M1owMTELMAkGA1UEBhMCQ04xDjAMBgNVBAoMBVpTSFpIMRIwEAYDVQQDDAnpmYjlr4zlvLowggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQD59p+p4oh58G6+rB2vcmHm+Z8XrI7WyJ/cQcoNBRWDZzzPMNQ0WB3oK0Dxnrio8Kz7l+rjbXjvU+A6s9AlarZia2BrneHVeqKHpB6tXJ0tgqWbIRLF3333leEYO5d5nHG3/nObI5eUlGmOLO9E/2TiM7MRMOvqOixHBoIkfxBMrjQbXCSa0WNkP6jTL6E1HWXJzOw4HwJNzTiw+cnvumrdnbTxOE5FR3znwn0iLn+M9svrSVQalR5DCtNrRjJs+zf2cL9YkUTlMzrhQiXQ/fqjQFQFPpV6eGE+nxhxsO9BbFEzbk01mGUZ/ujmoY2tzta4I2lYr3WwRycOoFpiKGBrAgMBAAGjggE9MIIBOTA9BgNVHR8ENjA0MDKgMKAuhixodHRwOi8vZ2ZhY2EuZ2ZhcGtpLmNvbS5jbi9nZmEvY3JsL2NybDMwLmNybDAOBgNVHQ8BAf8EBAMCBPAwHQYDVR0OBBYEFBOh0YdmIkRdYQlluYh8Yg1B6tePMIHIBgNVHSMEgcAwgb2AFJinRRwpAa8KCfiSHFueC7R83XlOoYGSpIGPMIGMMQswCQYDVQQGEwJDTjEQMA4GA1UECAwHQkVJSklORzEOMAwGA1UEBwwFQkVUREExDjAMBgNVBAoMBUNJRUNDMRowGAYDVQQLDBFHRkEgVFJVU1QgTkVUV09SSzEvMC0GA1UEAwwmUk9PVCBDRVJUSUZJQ0FURSBGT1IgR0ZBIFRSVVNUIE5FVFdPUkuCECeG7dHJFz4ZcwPmCSFvmJgwDQYJKoZIhvcNAQELBQADggEBAH4z4ZMyHku0/+x20FMD6DfGIAybvacW3v4eehwJtMPVKmBBTeE5rXQx8hVEovildt+4jEzq23spEUTKIdIm5GuZzBg8aAySIVgsO3K6fxwV/qR2NymdqX2MolL8c6YkwRPcDtwLiyHhi958EQdJyFpqsG8XB1FYjsVNVps7dpziA4nNrUNwytAAh+FLpj26PMdakZ8ClC6LYggi/9h3GgolMKev9Ao7jNu+vqFA6tPLgXMXn2OH1S1sIiPEcrlhcQCi3MXKYvAqn65/8iBGbmQkpbciXAzjZaYL9C36Rg7nQ4Vx9WPg0tjGJwepWOvpYTGKVWQpNp6uqVtSF0I+CR0='
        // }
        let data = {
          certPem: "MIIC5TCCAc2gAwIBAgIGAZ0ZXSuLMA0GCSqGSIb3DQEBCwUAMBIxEDAOBgNVBAMMB01vY2sgQ0Ew\r\nHhcNMjYwMzIyMDYyMzQ5WhcNMjYwNDIyMDYyMzQ5WjARMQ8wDQYDVQQDDAbpg63pnZ4wggEiMA0G\r\nCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDrlSHgOxtd7AOaKG59dCU+xaSmGJ459hEKQJstf450\r\nql6lkPo4jje1rMfDYl/aRkRNPtzvubp1bk7FFDE1i9jyjJ85ymkMk6opfoHNq3zuYLglEuNxVIEY\r\nj1WOGxBQlgFkzZQAveB978XSSTmFM7xQO532Vil4i6SeiS8V926s+vk7GZrklbK6luesecvBlf8n\r\nCg2LPYGFK+0Cz0OSrTCBmlG099VGhX+vUqs7camMig1VmEALs7FAUBVGClE9UEu2Pc4xevSHZHEA\r\nquNLrSAXL1qTv/Bg+bZCQs8lInk/Bu9HlxTcypStWrtFa971B1aiZwrqzKfnDiLe81cVyQRXAgMB\r\nAAGjQjBAMB0GA1UdDgQWBBSrIphbmOoK3R8e3i2EqoY/xBqVDDAfBgNVHSMEGDAWgBSrIphbmOoK\r\n3R8e3i2EqoY/xBqVDDANBgkqhkiG9w0BAQsFAAOCAQEAh+vqLTiUt20tJ/IsElXvDKHJn7k8PdvA\r\njRosq3hIfcJeMCCxyMBRsmnjt92nU2d4Sv2hV23uYGni0tCIzhGC8CpzwK4QZr9xXB43r24aTneE\r\n2KKEjjXVwAXwpwkR0495sv5onFkfdHgMNPBpQOcRfBsXPW5H5XAsg4abhuwTJRQqe1Q244HIQSUv\r\nYNbKIw1XvB6Fj4Gmp8cCtznGztrOJyPa3MPGAXo2ZagSfiWGBSgBaZM/EPcs15RU7g30liXFY03p\r\nz/blxEeQXf9OTZ7zoVl0HHyePwYNAwD3LkCr+2Pr1FhbxT4vSI9jtU9llqcwVKNUXkpIVtdGydG0\r\nxaeEzg==",
          privateKey: "MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDrlSHgOxtd7AOaKG59dCU+xaSmGJ459hEKQJstf450ql6lkPo4jje1rMfDYl/aRkRNPtzvubp1bk7FFDE1i9jyjJ85ymkMk6opfoHNq3zuYLglEuNxVIEYj1WOGxBQlgFkzZQAveB978XSSTmFM7xQO532Vil4i6SeiS8V926s+vk7GZrklbK6luesecvBlf8nCg2LPYGFK+0Cz0OSrTCBmlG099VGhX+vUqs7camMig1VmEALs7FAUBVGClE9UEu2Pc4xevSHZHEAquNLrSAXL1qTv/Bg+bZCQs8lInk/Bu9HlxTcypStWrtFa971B1aiZwrqzKfnDiLe81cVyQRXAgMBAAECggEAW+PYydjkTNdRdGEO7/pMyNZY6byygxM7BE+895tImrMVpekN4N+AVWnmpYyKrN45qBO8I/nDBCkZqn+8zhEVd05okScloJU8i2DgCrQ4T9cEHNnoQ31duZG3Im3mCDjqpEIX1844cYcEF4keWZmbe4Q1ki97j5yQgpIp/px73BZtYJioOp1y1PjIOjutgc02l0PfoL9hMqcL1G0/FzwlLr4z4wNDAqGh3Hvl1uiiuAgdl/TJaZJL+9v1z9LbHUZTTJ3R/sTAwVzlapovD1Xo4rIpHQ6HTe5xsk4Uo4vwX6wv/Mz5dt0c8zHs2fV6t8dkD4OdSDuxeHvrwDAWiMFqsQKBgQD6YVs6muxnxoARXULJpY5ufZgrm2ULabeRXBqFSLnrb+2nMnfupEAFMAPQm00WUJSRtMJHB1rPC/ob6Zc1eIfZK5Pru8hXiYISUl/0Le5g3VAtSAwPngujEz5fuwzYp4WpG8hmBtMPtGOYZ/mAmnHpijrQ9Ke5VCji/LxGblGaOQKBgQDw3sAj8qOFHQMgbSi67ovutooEvbFny9ZGU11kUvNvlOPo25Ot5JdAc8YVRbKItluDnn0XL99+G7NnAwOB/sCcQKU7VRK09xkSNI+OfcjCXVKTXG4vAotgQe/YlIKQyGj47fp2rR8/q1Wcvgm9lsJz7N0Is6sea9M7LP6qlATTDwKBgGFcMilbzMmduncGGM5ofjYgyGdMicIiXas8cWOaoBEY+QSm71PwsqRRw2n+ub8PnnX6IAGWro0MTzlDX/T+5XRhKafk4UaIxfdx6LX+lk88P80b0vTPtB65gOugxKIKokLb9tUVmkTlFEVTSQXlCJ6TjcNrHz1FqJB7Torkov6hAoGBAK5anzymM2V0pcHAIl6FtDb8XRWndhZLP3SyfYTUYrBfV0ZEQzb5o96cr0LQq7Y4QjAY9jVliuKPDKLBVLWxgRzZ0oELSLpDrxs1fsDHHh5LTS2sF3nh3p+zuvjML2K8Hvgp00Y6dMcyr4sBKK3axjEBwNG+tFwV8tX/8Ovqrz9TAoGALoRlx5hWNjAMl4FLKGYNLaPCkoCKxPUFsTXj0Fkan0982h6E6MyHQVK0BBWCyFlJWNPgtxJJFz+w1LeuEIi/m1mHGXz2RJJ9AX3WwOich/CsR9bjI2i+fbz+J3ZKDkBrzYM4sKk+oMzi4coxoiKoeYl686Ds15JLxLrkHOw/KJ0="
        }
        this.getEventCertPath(data)
      } else {
        this.getSealCertPaths(0)
      }
    },
    //
    getEventCertPath(data) {
      saveEventCertPath(this.$store.state.userInfo.userName, data).then(res => {
        if (res) {
          //this.eventCertPath = res
          this.signetList[0].certPath = res
          this.initDjSignFile()
        } else {
          this.showMessageInfoAlert('签名盖章流程获取签名证书路径报错，请联系管理员！', 0)
        }
      })
    },
    //
    getSealCertPaths(index) {
      if (index < this.signetList.length) {
        getSealCertPath(this.$store.state.userInfo.userName, this.signetList[index].certSn).then(res => {
          if (res) {
            this.signetList[index].certPath = res
            index++
            this.getSealCertPaths(index)
          } else {
            this.showMessageInfoAlert('签名盖章流程获取盖章证书路径报错，请联系管理员！', 0)
          }
        })
      } else {
        this.initDjSignFile()
      }
    },
    initDjSignFile() {
      this.$sealp('/api/doc/init?token=' + this.token,
        JSON.stringify({
          resId: this.staffId + '_' + this.resId,
          docId: this.docId,
          staffId: this.staffId
        }), this.appCode)
        .then((res) => {
          if (res.success && res.data) {
            this.fileId = res.data.fileId
            this.lockId = res.data.lockId
            this.downDjSignFile(res.data)
          } else {
            this.showMessageInfoAlert((res.message || res.messageDetail) + ',返回上一级重试！', 0)
          }
        }).catch(err => {
          this.showMessageInfoAlert('签名盖章流程初始化文件报错，请联系管理员！', 0)
        })
    },
    //
    downDjSignFile(file) {
      let url = (process.env.NODE_ENV === 'development' ? 'https://esign.sinopec.com' : window.location.origin) +
        '/seal/api/doc/file/fetch?token=' + this.token
      let fileName = 'document_' + Date.now() + '.pdf'
      // let postBody = JSON.stringify({
      //   fileId: file.fileId,
      //   enkey: ''
      // })
      let postBody = {
        fileId: file.fileId,
        enkey: ''
      }
      let headers = {
        'x-app-code': this.appCode,
        "Content-Type": "application/json;charset=UTF-8"
      }
      downDMToSBox(url, fileName, postBody, headers).then(res => {
        console.log('downDMToSBox', res, res.flag)
        if (res.flag) {
          startWhDjSignOrSeal(res.message, this.signetList)
        } else {
          this.showMessageInfoAlert('下载文件失败,返回上一级重试！', 0)
        }
      }).catch(err => {
        console.log('downDMToSBox-err', err)
        this.showMessageInfoAlert('签名盖章流程下载文件报错，请联系管理员！', 0)
      })
    },
    //
    showMessageInfoAlert(message, type, confirmButtonText = '确定') {
      this.$store.dispatch(this.$LoadShow, false)
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#0277FC'
      }).then(() => {
        closeCurrentPage(type)
      });
    },
    //网货点聚文件提交
    onDJSignOrSealResult(result) {
      if (result.message) {
        const binaryData = atob(result.message);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([uint8Array], {
          type: 'application/pdf'
        });
        const files = new File([blob], '', {
          type: 'application/pdf'
        })
        this.$sealp('/api/doc/sign/save/file?token=' + this.token, {
          docId: this.docId,
          segId: '',
          lockId: this.lockId,
          fileId: this.fileId,
          corpId: this.corpId,
          staffId: this.staffId,
          actType: 1,
          enKey: '',
          file: files
        }, this.appCode, 'form').then((res) => {
          if (res.success && res.data) {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast('提交成功！')
            setTimeout(() => {
              closeCurrentPage(1)
            }, 1000)
          } else {
            this.$store.dispatch(this.$LoadShow, false)
            this.showMessageInfoAlert('签名盖章流程提交文件失败，' + res.message || res.messageDetail, 0)
          }
        }).catch((err) => {
          console.log('catch--=', err)
          this.$store.dispatch(this.$LoadShow, false)
          this.showMessageInfoAlert('签名盖章流程提交文件失败，请联系管理员！', 0)
        });
      } else {
        this.$store.dispatch(this.$LoadShow, false)
        this.showMessageInfoAlert('签名盖章流程未获取到签署文件，请联系管理员！', 0)
      }
    },
    //初始化
    init() {
      this.resId = this.$route.query.resId
      this.docId = this.$route.query.docId
      this.corpId = this.$route.query.corpId
      this.staffId = this.$route.query.staffId
      this.certType = this.$route.query.certType
      this.signetType = this.$route.query.signetType
      this.segId = this.$route.query.segId
      this.appCode = this.$route.query.appCode
      this.getAppToken()
    },
  },
  mounted() {
    this.init()
  },
  created() {
    let that = this
    this.$jsbridge.registerHandler("onDJSignOrSealResult", function (data, responseCallback) {
      console.log('onDJSignOrSealResult', data)
      let result = JSON.parse(data)
      that.onDJSignOrSealResult(result)
    });
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

.file {
  width: 100%;
  height: 2rem;
  border: 1px solid #ccc;
  border-radius: 0.1rem;
  display: flex;
  padding: 0 0.5rem;
}

.corps {
  padding: 0.5rem;
  background-color: #f2f2f2;
  border-radius: 0.1rem;
  margin-bottom: 1rem;
}

.corps:last-child {
  margin-bottom: 0;
}

.corpsSelected {
  background-color: #81d3f825;
  border: 1px solid #02a7f0;
}

// 上链完成
.uploadCompleted {
  background-color: #d7d7d7;
  border-radius: 0.1rem;
}
</style>